import { stitch } from 'keo';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import NavigationMenu from 'material-ui/svg-icons/navigation/menu';
import { ToolbarGroup } from 'material-ui/Toolbar';
import PropTypes from 'prop-types';
import r from 'render-dom';
import { Link } from 'react-router-dom';

import HiddenOnSize from 'components/shared/HiddenOnSize';
import { MePropType } from 'proptypes/records';
import snagshoutMerchantLogo from 'images/snagshout-merchant-logo.png';

import SideMenu from './SideMenu';
import TabBar from './TabBar';
import UserDropdown from './UserDropdown';

const style = {
    a: { paddingTop: 20 },
    appBar: {
        borderBottom: '1px solid #bbb',
        boxShadow: 'none',
        flexWrap: 'wrap',
        paddingLeft: 15,
        paddingRight: 0,
        position: 'fixed',
    },
    iconStyle: {
        marginRight: 15,
        padding: 8,
    },
    logo: { maxWidth: 140 },
    navigationMenu: {
        height: 30,
        width: 30,
    },
    title: {
        alignItems: 'center',
        display: 'flex',
        height: 60,
        lineHeight: '60px',
    },
};

export const propTypes = {
    isLoggedIn: PropTypes.bool,
    me: MePropType.isRequired,
    pathname: PropTypes.string.isRequired,
    showSideMenu: PropTypes.bool.isRequired,
    toggleSideMenu: PropTypes.func.isRequired,
};

const render = ({ props: {
    isLoggedIn = false,
    pathname,
    me,
    showSideMenu,
    toggleSideMenu,
} }) => {
    return (
        r(AppBar, {
            iconElementRight: (
                r(HiddenOnSize, { sizes: ['md', 'lg'] }, [
                    r(IconButton, {
                        iconStyle: style.navigationMenu,
                        onClick: toggleSideMenu,
                        style: style.iconStyle,
                    }, [
                        r(NavigationMenu, { color: '#333' }),
                    ]),
                ])
            ),
            showMenuIconButton: false,
            style: style.appBar,
            title: (
                r(Link, {
                    style: style.a,
                    to: '/',
                }, [
                    r.img({
                        alt: 'Snagshout Merchant',
                        src: snagshoutMerchantLogo,
                        style: style.logo,
                    }),
                ])
            ),
            titleStyle: style.title,
        }, [
            r(TabBar, {
                isLoggedIn,
                me,
                pathname,
            }),
            r(SideMenu, {
                isLoggedIn,
                me,
                showSideMenu,
                toggleSideMenu,
            }),
            r(ToolbarGroup, { isRendered: me.get('id') }, [
                r(HiddenOnSize, { sizes: ['sm', 'xs'] }, [
                    r(UserDropdown, { pathname }),
                ]),
            ]),
        ])
    );
};

export default stitch({ propTypes, render });



// WEBPACK FOOTER //
// ./src/components/public/Navigation/NavigationBar/index.js